import { AppState } from '../../types'
import { ApiConfig, ApiAction } from './types'
import { Store, Dispatch } from 'redux'
import { API_GET, API_POST } from './actionTypes'

const api = (config: ApiConfig) => (store: Store) => (next: Dispatch) => async (action: ApiAction) => {

  switch(action.type) {

    case API_POST:
      // const { body } = action

    case API_GET:
      let options: RequestInit = {}

      const response = await fetch(config.host + action.url, options)
      const { status } = response
      if(status !== 200) {
        const state: AppState = store.getState()
        const { errors } = state.localization.translations
        throw new Error(errors[status])
      }

      return await response.json()

    default:
      next(action)

  }

}

export default api
